React = require 'react'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_team_of_member')

module.exports = class extends React.Component
  render: t.renderable ->
    { name, logoHash, displayName } = @props.item

    t.a { href: "/#{ name }", title: name }, ->
      t.div '.popover-item .u-clearfix', ->
        if logoHash
          t.img '.popover-item-image', src: [logoDomain, logoHash, '30.png'].join('/')
        else
          t.span '.popover-item-image.icon-lg.icon-organization'

        t.span '.popover-item-name', ->
          t.text displayName



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/team-of-member-component.coffee